import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import OutlineButton from '../Buttons/OutlineButton';
import DefaultButton from '../Buttons/DefaultButton';
import InlineButtonContainer from '../Buttons/InlineButtonContainer';
import typography from '../../../styling/mixins/typography';
import { openLogInModal } from '../../../redux/modals';
import { resetPassword } from '../../../redux/account';
import tracking from '../../../tracking/tracking';

import { StyledForm } from './AuthModalComponents/Form';
import { AccountContainer } from './ModalContainers/ModalContainers';

import { Main, Container, Section } from './AuthModalComponents/Layout';
import { ErrorMessage } from '../SiteTakeovers/Alerts';
import Input from '../Inputs/Input';

const Text = styled.p`
  ${typography.BasisFont};
  line-height: 1.5rem;
  margin: 1.25rem 0;
  text-align: left;
`;

const Cancel = tracking(
  styled(OutlineButton)`
    width: 50%;
  `,
  { identifier: 'cancel_password_reset' },
);
Cancel.displayName = 'Cancel';

const Submit = styled(DefaultButton)`
  width: 50%;
`;

export class ForgotPasswordModal extends Component {
  static propTypes = {
    errorMessage: PropTypes.string,
    openLogInModal: PropTypes.func.isRequired,
    resetPassword: PropTypes.func.isRequired,
  };

  state = {
    email: '',
  };

  createHandleChange = prop => e => {
    const value = e.target.value;

    return this.setState({ [prop]: value });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { email } = this.state;

    this.props.resetPassword(email);
  };

  render() {
    const { errorMessage, openLogInModal, isMobile } = this.props;

    return (
      <AccountContainer isMobile={isMobile}>
        <Main>
          <Container>
            <Section>
              <Text>
                Enter the email address associated with your account and we will
                send you an email to reset your password.
              </Text>
              <StyledForm onSubmit={this.handleSubmit}>
                {errorMessage.length ? (
                  <ErrorMessage>{errorMessage}</ErrorMessage>
                ) : null}
                <Input
                  onChange={this.createHandleChange('email')}
                  placeholder="Email"
                  type="email"
                  value={this.state.email}
                  required
                />
                <InlineButtonContainer width="100%" spacing="1rem">
                  <Cancel type="button" onClick={openLogInModal}>
                    Cancel
                  </Cancel>
                  <Submit type="submit">Submit</Submit>
                </InlineButtonContainer>
              </StyledForm>
            </Section>
          </Container>
        </Main>
      </AccountContainer>
    );
  }
}

const mapStateToProps = ({ account: { errorMessage }, env: { isMobile } }) => ({
  errorMessage,
  isMobile,
});

const mapDispatchToProps = {
  openLogInModal,
  resetPassword,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ForgotPasswordModal);
